module.exports = __webpack_public_path__ + "media/chest.03564440.mp3";